<template>
  <div class="d-flex h-100">
    <client-contact-history
      :contacts="contacts"
      :outreach-events="outreachEvents"
      :customer="customer"
    />
  </div>
</template>
<script>

export default {

  name: 'ClientContactHistoryContainer',

  data() {
    return {
    };
  },
  computed: {
    customer() {
      return this.$store.state.customers.item;
    },
    contacts() {
      if (!this.customer) return { count: 0, items: [] };
      return {
        count: this.$store.state.outreachs.customerOutReachContactsCount,
        items: this.$store.state.outreachs.customerOutReachContacts,
      };
    },
    outreachEvents() {
      return this.$store.state.events.filteredItems;
    },
  },
};
</script>
<style lang="css" scoped>
</style>
